// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2J6DE","right":"Footer_right__2Tw3R","buttons":"Footer_buttons__23My8"};